import React from 'react';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import './MobileButton.sass';

export const MobileButton = ({icon, title, onClick, active, dataQaId}) => (
  <div onClick={onClick} role="button">
    <Button
      id="navBottom"
      className={`card_editor__mobile__button ${
        active ? 'card_editor__mobile__button--active' : ''
      }`}
      variant="secondary"
      size="small"
      data-qa-id={dataQaId}
    >
      {icon}
    </Button>
    <Typography variant="paragraph3" classNames="card_editor__mobile__button__title">
      {title}
    </Typography>
  </div>
);
